const sugarcubeEvents = {
  sugarcubeView: {
    action: "view",
  },
  sugarcubeOpen: {
    action: "open",
  },
  sugarcubeClose: {
    action: "close",
  },
  sugarcubeAddProduct: {
    action: "add_product",
  },
  sugarcubeMoveProduct: {
    action: "move_product",
  },
  sugarcubeRemoveProduct: {
    action: "remove_product",
  },
  sugarcubeLoadComplete: {
    action: "load_complete",
  },
  sugarcubeGraphicsCheck: {
    action: "graphics_check",
  },
  sugarcubeAddRoomToBag: {
    action: "add_room_to_bag",
  },
  sugarcubeAddToBag: {
    action: "add_to_bag",
  },
  sugarcubeSave: {
    action: "save",
  },
};

export default sugarcubeEvents;
